import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useSelector } from "react-redux";
import { Quicksale_Get_Row_Api } from "../../Server/Apis";
import moment from "moment";
import axios from "axios";
import { ORDER_DETAIL_GETROW_API } from "../../Server/ApiV2";

const OrderPicking = () => {
  const [fromDate, setFromDate] = useState(moment().subtract(1, "days"));
  const [toDate, setToDate] = useState(moment());
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ordersLoading, setOrdersLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const { UserID } = useSelector((state) => state.login.value);

  const handleFilter = async () => {
    setOrdersLoading(true);
    try {
      const payload = Quicksale_Get_Row_Api({
        StartDate: moment.utc(fromDate).format("MM/DD/YYYY"),
        EndDate: moment.utc(toDate).format("MM/DD/YYYY"),
        PickingStatus: "",
        DeliveryStatus: "",
        User: UserID || "",
      });
      const res = await axios(payload);
      setFilteredOrders(res?.data?.ResultSet || []);
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setOrdersLoading(false);
    }
  };

  const handleOpen = async (order) => {
    setSelectedOrder(order);
    setOpen(true);
    setLoading(true);
    try {
      const response = await ORDER_DETAIL_GETROW_API({ ID: order?.ID || "" });
      setTableData(response.data?.ResultSet || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedOrder(null);
    setTableData([]);
  };

  useEffect(() => {
    handleFilter();
  }, []);

  return (
    <>
      {/* Filters Section */}
      <Grid container spacing={2} mb={3}>
        <Grid item xs={12} sm={6} md={3}>
          <DatePicker
            label="From Date"
            value={fromDate}
            onChange={(newValue) => setFromDate(newValue || moment())}
            renderInput={(params) => <TextField {...params} fullWidth />}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DatePicker
            label="To Date"
            value={toDate}
            onChange={(newValue) => setToDate(newValue || moment())}
            renderInput={(params) => <TextField {...params} fullWidth />}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: { xs: 2, sm: 0 } }}
            onClick={handleFilter}
          >
            Apply Filters
          </Button>
        </Grid>
      </Grid>

      {/* Orders Section */}
      <Box>
        <Typography variant="h6" mb={2}>
          Orders
        </Typography>
        {ordersLoading ? (
          <Box display="flex" justifyContent="center" mt={2}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={2}>
            {filteredOrders.length > 0 ? (
              filteredOrders.map((order) => (
                <Grid item xs={12} sm={6} md={4} key={order.ID}>
                  <Card
                    sx={{
                      borderRadius: 2,
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      transition: "transform 0.3s ease",
                      "&:hover": { transform: "scale(1.05)" },
                    }}
                  >
                    <CardActionArea onClick={() => handleOpen(order)}>
                      <CardContent>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold", color: "#1976d2" }}
                        >
                          Order ID: {order.ID}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Date:</strong> {order.OrderTime}
                        </Typography>
                        <Typography variant="body2">
                          <strong>User:</strong> {order.OrderUserName}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Car Model:</strong> {order.CarModel}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Location:</strong> {order.LocName}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))
            ) : (
              <Typography variant="body1" mt={2}>
                No orders found.
              </Typography>
            )}
          </Grid>
        )}
      </Box>

      {/* Dialog Section */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          {selectedOrder
            ? `Order Details - Order ID: ${selectedOrder.ID}`
            : "Order Details"}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <Box display="flex" justifyContent="center" mt={2}>
              <CircularProgress />
            </Box>
          ) : (
            <Box>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow
                      style={{ backgroundColor: "#b71c1c", color: "#fff" }}
                    >
                      <TableCell style={{ color: "#fff" }}>Bar Code</TableCell>
                      <TableCell style={{ color: "#fff" }}>Item Name</TableCell>
                      <TableCell style={{ color: "#fff" }}>Order Qty</TableCell>
                      <TableCell style={{ color: "#fff" }}>
                        Picked Qty
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row.Barcode}</TableCell>
                        <TableCell>{row.ItmName}</TableCell>
                        <TableCell>{row.Qty}</TableCell>
                        <TableCell>{row.RSP?.toFixed(2)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OrderPicking;
